import React, { useEffect } from "react";
import { Spin, Card, Button, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useAgentEntitlements } from "./useAgentEntitlements";
import { navigateAgentPackageUpgrade } from "../../utils/agentUpgradeNavigation";

const { Title, Paragraph } = Typography;

/**
 * Route guard לאזור הגדרות אתר הסוכן — SSOT: canUseAgentPublicSite (כולל אדמין אפקטיבי PRO).
 */
export function AgentPublicSiteGate({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    status,
    loading,
    canUseAgentPublicSite,
    effectivePackageCode,
  } = useAgentEntitlements();

  const allowed = Boolean(canUseAgentPublicSite);

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    console.log("[AGENT_SITE_ACCESS_GUARD]", {
      effectivePackageCode,
      canUseAgentPublicSite,
      route: location.pathname,
    });
  }, [canUseAgentPublicSite, effectivePackageCode, location.pathname]);

  if ((loading || status === "idle") && !allowed) {
    return (
      <div style={{ padding: 48, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!allowed) {
    return (
      <div style={{ padding: 24, maxWidth: 520, margin: "48px auto" }} dir="rtl">
        <Card>
          <Title level={3} style={{ marginTop: 0 }}>
            האתר שלך מחכה לך 🚀
          </Title>
          <Paragraph>פיצ'ר אתר סוכן זמין בחבילת PRO ומעלה</Paragraph>
          <Button
            type="primary"
            onClick={() => navigateAgentPackageUpgrade(navigate, "agent_public_site_gate")}
          >
            שדרג עכשיו
          </Button>
        </Card>
      </div>
    );
  }

  return children;
}
